import * as am5 from "@amcharts/amcharts5";

export const Am5Settings = {
    // Actual setting to use UTC or company timezone
    useUTC: false,

    // The Actual setting on whether we use short gaps.
    useShortGaps: false,

    // Handler to update the UI Component (Use Sparingly)
    updateVueHook: null,

    // Group Count — used by getIntervals() to compute baseInterval for axis labels
    GROUP_COUNT: 750,

    // Axis group count — am5 switches to grouped data when visible items exceed this.
    // Lower than GROUP_COUNT so grouping activates sooner (am5 factors in chart width).
    AXIS_GROUP_COUNT: 200,

    // Axis location descriptors
    AXIS_LEFT: 0,
    AXIS_RIGHT: 1,

    // Loading Intervals
    RELOAD_FREQUENCY: 1000,
    RELOAD_FREQUENCY_FINISHED: 10000000,
    LOAD_DATA_DELAY: 50,

    // Bullet Density
    MIN_BULLET_DISTANCE: 10,

    // Gap Length in Minutes
    SHORT_GAP_LENGTH: 30,
    LONG_GAP_LENGTH: 12 * 60,

    Y_AXIS_SPACE_PERCENT: 0.05,

    FATHOM_GOALS: {
        showSeries: '23DDHL1I',
        showPairedPoint: 'AFOFOVBO',
        addNewSeriesToPlot: 'RUSGFGJS',
    },

    BACK_FILL_COLOR: am5.color('#cccf1c'),
    COLOR_ALARM: am5.color('#8f000f'),
    COLOR_CAUTION: am5.color('#bfcf29'),
}
